(function ($) {
    $(function () {
        api.fn.checkTouchDevice();

        api.vars.isIE = !!window.MSInputMethodContext && !!document.documentMode;

        var lang = $("html").attr("lang");
        if (lang) api.vars.lang = lang;

        jQuery.datepicker.setDefaults(jQuery.datepicker.regional["" + api.vars.lang + ""]);

        //api.components.iniResponsive();

        api.fn.toFocus();
        api.fn.getWindDims();
        api.fn.onEnterTriggerBtn();
        api.fn.onEscTriggerReset();
        api.fn.zoomLevel();
        api.fn.iniShareLinks();
        api.fn.modalLnk();
        api.fn.redirectToJobPage();

        // forms

        //api.components.responsiveImgs();

        // header
        $(".header").header();
        $(".header-mob").header_mob();

        // footer
        $(".footer").footer();

        // lazy load
        $("[data-src]").lazy();

        // widgets
        $(".b-accordion").accordionSection({
            header: ".b-accordion__head",
        });

        $(".s-profile__carousel").w_profileCarousel();
        $(".s-hero").hero();
        $(".s-hero-main").hero_main();
        $(".s-news-grp__gal--feat").news_grp();
        $(".s-news-grp__gal--news").news_grp_news();
        $(".s-insights-slider__col--news").insightsSlider();
        $(".s-insights-slider__col--feat").animatedCardSlider();
        $(".s-about-us").about();
        $(".s-tabs").w_tabs();
        $(".s-boxes").w_boxesCarousel();
        $(".b-aside-menu").asideMenu();
        $(".s-services__aside").asideMenu();
        $(".s-history").w_historyCarousel();
        $(".s-certificate").w_certificateCarousel();
        $(".s-board").w_boardCarousel();
        $(".s-members").w_membersCarousel();
        $(".s-about__dropdown").w_mobDropdown();
        $(".header-mob__menu").menuMobile();
        $(".s-related-lnks").w_relatedLnks();
        $(".s-about").w_stickyLnks();
        $(".s-services-cards--carousel").w_servicesCardsCarousel();
        $(".s-services").w_servicesTabs();

        //for better height in mobile
        const appHeight = () => {
            const doc = document.documentElement;
            doc.style.setProperty("--app-height", `${window.innerHeight}px`);
        };
        window.addEventListener("resize", appHeight);
        appHeight();

        // ini rest page script block elements used with docReady
        $.each(jsCallbacks, function (i, val) {
            val($);
        });

        $(document).trigger("ini-ready");

        // resize
        $(window).on("resize", function () {
            // api.forms.resizeCaptch();
            api.fn.getWindDims();
            //api.components.responsive();
            api.fn.zoomLevel();

            $(document).trigger("window-resized");
        });

        $(window).on("load", function () {
            $(document).trigger("window-loaded");
        });

        if (!api.vars.pagemode_edit) {
            $(".inViewport").inViewport();
        } else {
            $(".inViewport").removeClass("inViewport");
        }

        setTimeout(() => {
            document.body.classList.add("dom-ready");
        });
    });
})(jQuery);
